/*
 * @Author: bbqin
 * @Date: 2022-10-20 13:37:21
 * @LastEditTime: 2023-07-06 14:56:50
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\libs\dnd\item.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';
import { DragSource, DropTarget, DragLayer } from 'react-dnd';
import { findDOMNode } from "react-dom";
import { ItemTypes } from './ItemTypes';

//  流程 beginDrag -- hover -- drop -- endDrag
const spec = {
    beginDrag(props, monitor, component) {
        const result = props.onStart?.(props, monitor, component) || {
            index: props.index,
            type: ItemTypes.ITEM,
        };
        // monitor.getItem的数据
        return result;
    },

    endDrag(props, monitor, component) {
        const result = props.onStop?.(props, monitor, component);
    },

    canDrag(props, monitor) {
        const draggable = props.shouldDrag?.(props, monitor, 'source') || props?.draggable;
        return draggable;
    },
};

const collect = (connect, monitor) => ({
    // 这里返回一个对象，会将对象的属性都赋到组件的 props 中去。这些属性需要自己定义。
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
    // result: monitor.getDropResult(),
    // itemType: monitor.getItemType(),
    // item: monitor.getItem(),
    // dropResult: monitor.getDropResult(),
    // didDrop: monitor.didDrop(),
    // initialClientOffset: monitor.getInitialClientOffset(),
    // initialSourceClientOffset: monitor.getInitialSourceClientOffset(),
    // clientOffset: monitor.getClientOffset(),
    // differenceFromInitialOffset: monitor.getDifferenceFromInitialOffset(),
    // sourceClientOffset: monitor.getSourceClientOffset(),
});

const targetSpec = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        if (dragItem.type === "item") {
            //释放的分组对象
            props.moveItem(dragItem.index, props.index);
        }
    },

    hover(props, monitor, component) {
        if (!props?.draggable) {return;}
        if (!props?.droppable) {return;}
        const dragItem = monitor.getItem();
        if (dragItem.type === "item") {
            // hover到Item，根据是否超过hover Item高度的一半来判断是否需要重新排序
            const dragIndex = monitor.getItem().index;
            const hoverIndex = props.index;

            if (dragIndex === hoverIndex) {
                return;
            }
            const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

            const clientOffset = monitor.getClientOffset();

            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }

            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            props.moveItem(dragIndex, hoverIndex);

            monitor.getItem().index = hoverIndex;
        }
    },

    canDrop(props, monitor) {
        return props?.droppable;
    },
};

const targetCollect = (connect, monitor) => ({
    // 这里返回一个对象，会将对象的属性都赋到组件的 props 中去。这些属性需要自己定义。
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
});

@DropTarget(ItemTypes.ITEM, targetSpec, targetCollect)
@DragSource(ItemTypes.ITEM, spec, collect)
// @DragLayer((monitor, props) => ({
//     isDragging: monitor.isDragging(),
// }))
class DragItem extends Component {
    render() {
        const {
            connectDragSource,
            connectDropTarget,
            connectDragPreview,
            isDragging,
            className,
        } = this.props;

        const style = isDragging ? {
            backgroundColor: '#fff',
            boxShadow: '0px 0px 4px 1px rgba(88,146,201,0.36)',
        } : {};

        const cls = ` setting-dnd-item ${isDragging ? ' dnd-item-dragging ' : '  '} ${className || ''}`;

        return (
            <>
                {
                    connectDragPreview(
                        connectDropTarget(
                            connectDragSource(
                                <div
                                    className={cls}
                                    style={style}
                                >
                                    {this.props.children}
                                </div>,
                            )),
                        {
                            backgroundColor: '#fff',
                            boxShadow: '0px 0px 4px 1px rgba(88,146,201,0.36)',
                            style: {
                                backgroundColor: '#fff',
                                boxShadow: '0px 0px 4px 1px rgba(88,146,201,0.36)',
                            },
                        })
                }
            </>
        );
    }
}

export default DragItem;